import { FunctionComponent, useContext, useEffect, useState } from "react";
import TitleText from "../../components/shared-components/dashboard/TitleText";
import styles from "./Affiliate.module.css";
import images from "../../assets/images";
import AppTable from "../../components/shared-components/table/AppTable";
import { Button, CircularProgress, Dialog, Menu } from "@mui/material";
import AddAffiliate from "../../components/shared-components/add-affiliate/AddAffiliate";
import { useLazyQuery } from "@apollo/client";
import { AFFILIATE_TYPE_BOTH, GET_AFFILIATE_COUNT, GET_AFFILIATE_COUNT_BY_MARKETING_USER, GET_AFFILIATES, GET_ALL_AFFILIATES } from "./api/AffiliateQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";
import { globalContext } from "../../Provider/AppProvider";
import PopupComponent from "../../components/shared-components/success-popup/PopupComponent";
import { CustomPaperComponent, getFormattedDate, roles } from "../../helper";
import stylesUser from '../Users/Users.module.css'
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import AffiliateFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/AffiliateFilterDropdown";

interface usersUnderAffiliateUser {
    id: string,
    affiliateId: string,
    userFullName: string,
    affiliater_ticket_details: any,
    totalEarnings: number | null,
    noOfUsers: any
}
export interface affiliateUser {
    firstName: string,
    lastName: string,
    emailId: string,
    user: usersUnderAffiliateUser
}


interface affiliateCount{
  aggregate: {
    count: number
  }
}
export interface getAffiliates {
  aId: string,
  aType: string,
  totalAmount: number,
  directPayout: number,
  emailId: string,
  firstName: string,
  indirectPayout: number,
  lastName: string,
  noOfAffiliates: number | null,
  noOfUsers: number | null,
  referralCode: string | null,
  uId: string,
  userFullName: string,
  aStatus: string,
  aCreatedAt: string,
  aUpdatedAt: string,
  aOrganization: string
}
export interface affiliateUsersListType {
  getAffiliates : getAffiliates[],
  getAffiliatesCount: number,
}

const Affiliate: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const { dropdownIcon, GreyFilterIcon} = images;
  const { AddIcon } = images;
  const StyledComponent = CustomPaperComponent();
  const {error} = ToasterWithMessage();
  const [affiliateDetailsView, setAffiliateDetailsView] = useState<boolean>(false);
  const title = affiliateDetailsView ? "Affiliates Transactions" : "Affiliates";
  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(tempRowsPerPage ? tempRowsPerPage : "") || 10
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [checking, setChecking] = useState<boolean>(false);
  const [selected, setSelected] = useState<number[]>([]);
  const [columnTypes, setColumnTypes] = useState<string>("aUpdatedAt");
  const [sortType, setSortType] = useState<string>("desc");
  const [affiliateUsers, setAffiliateUsers] = useState<affiliateUsersListType>();
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const {globalState, handleGlobalState} = useContext <any>(globalContext)
  const [affiliateSuccess, setAffiliateSuccess] = useState<boolean>(false);
  const [searchvalue, setSearchvalue] = useState(globalState?.globalSearch?.searchtext);
  const [anchorElFilter, setAnchorlFilter] = useState(null);
  const openFilter = Boolean(anchorElFilter);
  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata?.globalSearch?.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  const [getAllAffiliates,{loading}] = useLazyQuery(GET_AFFILIATES,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setAffiliateUsers((prevState) => ({
        ...prevState,
        getAffiliates: data?.getAffiliates,
        getAffiliatesCount: prevState?.getAffiliatesCount ?? 0
      }));
      const tempData = {...globalState};
      if(tempData.affiliateAdded.added){
        setAffiliateSuccess(true);
        tempData.affiliateAdded.added = false;
      }
      if(tempData.affiliateDelete.deleted){
        tempData.affiliateDelete.deleted = false;
      }
      if(tempData.affiliateUpdate.updated){
        tempData.affiliateUpdate.updated = false;
      }
      handleGlobalState(tempData);
    },
    onError: () => {
      error("Something went wrong!");
    }
  })
  const [getAffiliateCount] = useLazyQuery(globalState.profile.userRole !== "marketing_user" ? GET_AFFILIATE_COUNT : GET_AFFILIATE_COUNT_BY_MARKETING_USER, {
    fetchPolicy: "no-cache",
    onCompleted: (data)=>{
      setAffiliateUsers((prevState) => ({
        ...prevState,
        getAffiliates: prevState?.getAffiliates ?? [],
        getAffiliatesCount: data?.GetAffiliatesCount?.[0]?.totalCount ?? prevState?.getAffiliatesCount ?? 0
      }));
    },
    onError : () =>{
      error("Failed to fetch affiliate records");
    }
  })
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTempRowsPerPage(event.target.value);
  };

  const handlePageChange = (_event: any, newPage: any) => {
    setCurrentPage(newPage);
    setChecking(false);
    setSelected([]);
  };

  const GenerateUsersHeadCells = () => {
    let affiliateType: string | undefined = 'Direct';
    if(globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
      affiliateType = affiliateUsers?.getAffiliates?.[0]?.aType
    }
    let id = [
      "firstName",
      "firstName",
      "lastName",
      "aOrganization",
      "emailId",
      "aStatus",
      "aType",
      "noOfUsers",
      "totalAmount",
      "directPayout",
      "action",
    ];
    let labels = [
      "Affiliate ID",
      "First Name",
      "Last Name",
      "Organization",
      "Email",
      "Status",
      "Type",
      "Number Of Users",
      "Earned Amount",
      "Direct Payout",
      "Referral Url",
    ];
    if(globalState.affiliateFilter.typeName === "Indirect" || affiliateType === "Indirect" ){
      id = [
        "firstName",
        "lastName",
        "aOrganization",
        "emailId",
        "aStatus",
        "aType",
        "noOfAffiliates",
        "totalAmount",
        "indirectPayout",
        "action",
      ];
      labels = [
      "First Name",
      "Last Name",
      "Organization",
      "Email",
      "Status",
      "Type",
      "Number Of Affiliates",
      "Earned Amount",
      "InDirect Payout",
      "Referral Url",
      ]
    } else if (globalState.affiliateFilter.typeName === "Both" || affiliateType === "Both" ){
      id = [
        "firstName",
        "firstName",
        "lastName",
        "aOrganization",
        "emailId",
        "aStatus",
        "aType",
        "noOfUsers",
        "noOfAffiliates",
        "totalAmount",
        "directPayout",
        "indirectPayout",
        "action",
      ];
      labels = [
        "Affiliate ID",
        "First Name",
        "Last Name",
        "Organization",
        "Email",
        "Status",
        "Type",
        "Number Of Users",
        "Number Of Affiliates",
        "Earned Amount",
        "Direct Payout",
        "InDirect Payout",
        "Referral Url",
        ]
    }
    if(affiliateDetailsView) {
      id = [
        "ut_transaction_id",
        "ut_transaction_amount",
        "ut_created_at",
        "ut_type"
      ];
      labels = [
        "Transaction Id",
        "Amount",
        "Transaction Time",
        "Type"
      ];
    }
    const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
  };

  const handleOpenDialogAddAffiliate = () =>{
    setOpenDialog(true)
  }

  const handleCloseDialogAddAffiliate = () =>{
    setOpenDialog(false)
  }
  useEffect(() => {
    getAllAffiliates({
      variables: {
        limit: 10,
        offset: 0,
        order_by: {[columnTypes]: sortType},
        searchText: `%${searchvalue}%`,
        aStatus: globalState.affiliateFilter.status ? [globalState.affiliateFilter.status] : ["Active", "Deactive"],
        aType: globalState.affiliateFilter.typeName ? [globalState.affiliateFilter.typeName] : ["Both"]
    }
    })
    if(globalState.profile.userRole !== roles.AFFILIATER_ADMIN) {
      getAffiliateCount({
        variables:{
          searchText: `%${searchvalue}%`,
          aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
          aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=> {
    getAllAffiliates({
      variables: {
        limit: rowsPerPage,
        offset: (currentPage -1)*rowsPerPage,
        order_by: {[columnTypes]: sortType},
      searchText: `%${searchvalue}%`,
      aStatus: globalState.affiliateFilter.status ? [globalState.affiliateFilter.status] : ["Active", "Deactive"],
      aType: globalState.affiliateFilter.typeName ? [globalState.affiliateFilter.typeName] : ["Both"]
    }
    })
    if (globalState.profile.userRole !== roles.AFFILIATER_ADMIN) {
      getAffiliateCount({
        variables:{
          searchText: `%${searchvalue}%`,
          aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
          aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentPage,rowsPerPage,sortType,columnTypes,getAllAffiliates])

  useEffect(() => {
    getAllAffiliates({
      variables: {
        limit: rowsPerPage,
        offset: (currentPage -1)*rowsPerPage,
        order_by: {[columnTypes]: sortType},
      searchText: `%${searchvalue}%`,
      aStatus: globalState.affiliateFilter.status ? [globalState.affiliateFilter.status] : ["Active", "Deactive"],
      aType: globalState.affiliateFilter.typeName ? [globalState.affiliateFilter.typeName] : ["Both"]
    }
    })
    if(globalState.profile.userRole !== roles.AFFILIATER_ADMIN) {
      getAffiliateCount({
        variables:{
          searchText: `%${searchvalue}%`,
          aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
          aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState?.globalSearch?.searchtext,searchvalue,globalState.affiliateFilter.typeName,globalState.affiliateFilter.status])
  
  useEffect(()=>{
    if(globalState.affiliateAdded.added || globalState.affiliateDelete.deleted || globalState.affiliateUpdate.updated){
      getAllAffiliates({
        variables: {
          limit: rowsPerPage,
          offset : (currentPage -1)*rowsPerPage,
          order_by: {[columnTypes]: sortType},
        searchText: `%${searchvalue}%`,
        aStatus: globalState.affiliateFilter.status ? [globalState.affiliateFilter.status] : ["Active", "Deactive"],
        aType: globalState.affiliateFilter.typeName ? [globalState.affiliateFilter.typeName] : ["Both"]
      }
      })
      if(globalState.profile.userRole !== roles.AFFILIATER_ADMIN) {
        getAffiliateCount({
          variables:{
            searchText: `%${searchvalue}%`,
            aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
            aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
          }
        })
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.affiliateAdded.added,globalState.affiliateDelete.deleted,globalState.affiliateUpdate.updated])


  
  const handleCloseSuccessDialog = () => {
    setAffiliateSuccess(false);
    const tempValue = {...globalState};
    tempValue.afterCreatedAffiliate.referalLink = "";
    handleGlobalState(tempValue);
  }

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

  const [affiliateTypeBoth] = useLazyQuery(AFFILIATE_TYPE_BOTH,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const tempState = {...globalState};
      tempState.affiliateFilter.typeName = data?.affiliate_type?.[0]?.type || "Both";
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const date = getFormattedDate(new Date());
    const tempState = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempState.globalSearch.searchtext = "";
      tempState.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempState.notification.notificationClicked = false;
      tempState.notification.tp_id_array=null;
      tempState.globalSearch.searchtext = "";
      tempState.notification.text = "";
      tempState.notification.ticketId =null;
      tempState.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempState.error.errorClicked = false;
      tempState.globalSearch.searchtext = "";
      tempState.error.text = "";
      tempState.error.approximateTpArray = null
      tempState.error.ticketPlacementId = null
      tempState.error.status = ""
    }else if(globalState.soldTickets.failed){
      tempState.soldTickets.failed = false
      tempState.globalSearch.searchtext = "";
      tempState.soldTickets.emailId = "";
    }
    if(!tempState.affiliateFilter.typeId && !tempState.affiliateFilter.typeName){
      affiliateTypeBoth();
    }
    handleGlobalState(tempState)
    if(globalState.profile.userRole !== "marketing_user"){
      getWebNotification({
        variables:{
          todayDate: date,
          userId: globalState?.profile?.id
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const handleClickopenFilter = (event: any) => {
    setAnchorlFilter(event.currentTarget);
  }

  const handleCloseFilter = () => {
    setAnchorlFilter(null);
  };

  return (
    <div style={{ width: "100%" }}>
      <>
        <div className={styles.userHeading}>
          <TitleText title={title} />
          {(globalState.globalSearch.searchtext !== '') && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({affiliateUsers?.getAffiliates?.length})</span></div>}
          { globalState.profile.userRole !== roles.AFFILIATER_ADMIN &&
            <div className={styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
               <img src={GreyFilterIcon} alt={"filtericon"} /> 
              </span>
              <span>Filter</span>
            </div>
          }
          { (globalState.profile.userRole === roles.MARKETING_USER || globalState.profile.userRole === roles.AFFILIATER_ADMIN) ?
            null :
            <div className={styles.addAffiliate} onClick={handleOpenDialogAddAffiliate}>
            <Button
              classes={{ root: styles.separateStyle }}
              disableRipple
              fullWidth
              type="submit"
            >
             <img src={AddIcon} alt="addIcon" className={styles.addIcon}/>Add
            </Button>
          </div>}
        </div>
        {
          loading
        ?  
          <div className={stylesUser.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
        :
        <AppTable
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handlePageChange={handlePageChange}
          setColumnTypes={setColumnTypes}
          sortType={sortType}
          setSortType={setSortType}
          setSelected={setSelected}
          setChecking={setChecking}
          checking={checking}
          selected={selected}
          rowsPerPage={rowsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          list={affiliateUsers}
          tableTitle="affiliate"
          generateHeadCells={GenerateUsersHeadCells}
          affiliateDetailsView={affiliateDetailsView}
          setAffiliateDetailsView={setAffiliateDetailsView}
        />
        }
      </>
      <Dialog open={openDialog} classes={{paper:styles.customDialog}}>
        <AddAffiliate handleCloseDialog={handleCloseDialogAddAffiliate} isEdit={false} setColumnTypes={setColumnTypes} setSortType={setSortType}/>
      </Dialog>
      <Dialog open={affiliateSuccess} PaperComponent={StyledComponent}>
          <PopupComponent 
           handleClose={handleCloseSuccessDialog}
           title={"Affiliate Created Successfully!"}
           subTitle={globalState.afterCreatedAffiliate.referalLink}
           />
        </Dialog>

        <Menu
            anchorEl={anchorElFilter}
            id="account-menu"
            open={openFilter}
            onClose={handleCloseFilter}
            transformOrigin={{ horizontal: "left", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            MenuListProps={{
              disablePadding: true,
            }}
            classes={{
              paper: styles.customMenu,
            }}
          >
            <AffiliateFilterDropdown  handleCloseFilterDropDown={handleCloseFilter}/>
          </Menu>
    </div>
  );
};

export default Affiliate;
